// validateModule.js

import { propertyValidationConfig } from "./validationConfig";

export const validateListing = ({
  listingType,
  ApartmentData,
  VillaData,
  PlotsData,
}) => {
  const errors = {};

  const moduleDataMap = {
    Apartments: ApartmentData,
    Villas: VillaData,
    Plots: PlotsData,
  };

  const requiredFields = propertyValidationConfig[listingType];

  if (!requiredFields) return errors;

  const data = moduleDataMap[listingType] || {};

  requiredFields.forEach((field) => {
    if (!data[field] || data[field].toString().trim() === "") {
      errors[field] = `${field} is required`;
    }
  });

  return errors;
};